module.exports = __webpack_public_path__ + "img/4.a12dc7e6.png";